import {GoogleMap} from "@react-google-maps/api";
import React, {useContext, useEffect, useMemo, useState} from "react";
import GeofenceActionsModal from "./Modals/ActionModals/GeofenceActionsModal";
import {toast} from "react-toastify";
import {deleteGeofence} from "API/companyApi";
import ActionModal from "./Modals/ActionModals/ActionModal";
import {SalvoContext} from "contexts/SalvoContext";
import {centerOfGeofence,} from "../utils/utils";
import {isPointInPolygon} from "geolib";
import ChooseGeofenceModal from "./Modals/ChooseGeofenceModal";
import useLocation from "../Hooks/useLocation";
import LoadingSpinner from "./Loading/LoadingSpinner";
import {useTranslation} from "react-i18next";
import useFitBounds from "../Hooks/useFitBounds";
import {faCheckCircle, faEye, faEyeSlash, faTimesCircle,} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {isCurrentTimeBetween} from "../../src/utils/DateTimeUtills";
import {Col} from "react-bootstrap";
import MapControl from "./Map/MapControl";
import ConditionalRender from "./ConditionalRender";
import GeofencesDisplay from "../pages/GeofencePage/Components/GeofencesDisplay";

const GeofencesMap = ({ geofences, onDelete, focusedGeofence, containerStyle, handleMapClick, handleGeofenceClick, colorIfActive = true, enableFilter = true, useClustering= true }) => {
  const { setCopiedGeofence } = useContext(SalvoContext)
  const { userLocation, isLoading } = useLocation({ lat: 51.441277, lng: 5.476341 }) //Eindhoven
  const {t} = useTranslation()

  const [filterType, setFilterType] = useState("all");
  const [incomingGeofences, setIncomingGeofences] = useState(geofences);
  const [currentMapZoom, setCurrentMapZoom] = useState(14);

  const center = useMemo(() => {
    if (focusedGeofence)
    {
      if (focusedGeofence.enlargedPoints) // TODO: Only return that if the filter type is showing the enlarged geofences.
      {
        return centerOfGeofence(focusedGeofence.enlargedPoints);
      }

      return centerOfGeofence(focusedGeofence.points);
    }

    return userLocation;
  }, [focusedGeofence, userLocation]);

  //Zoom the map if geofence is selected
  const [mapInstance, setMapInstance] = useState(null);

  useFitBounds(mapInstance, focusedGeofence, true);

  const handleMapLoad = (map) => {
    // Store map instance when it's loaded
    setMapInstance(map);
  };

  async function onDeleteGeofence() {
    await deleteGeofence(selectedGeofence.id);
    onDelete();
  }

  const [geofencesToChooseFrom, setGeofencesToChooseFrom] = useState([]);
  const [selectedGeofence, setSelectedGeofence] = useState();
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);

  // function getOptionsForGeofence(geofence) {
  //   if (colorIfActive) {
  //     const isActive = geofenceIsActive(geofence);
  //     if (geofence.color) {
  //       if (isActive) {
  //         return {
  //           strokeColor: "#64bc5c",
  //           strokeOpacity: 0.8,
  //           strokeWeight: 3,
  //           fillColor: geofence.color,
  //           fillOpacity: 0.5,
  //         };
  //       } else {
  //         return {
  //           strokeColor: "#FF0000",
  //           strokeOpacity: 0.8,
  //           strokeWeight: 3,
  //           fillColor: geofence.color,
  //           fillOpacity: 0.5,
  //         };
  //       }
  //     } else {
  //       return optionsForGeofence(geofence, isActive);
  //     }
  //   } else {
  //     return {
  //       strokeColor: "#3e79cc",
  //       strokeOpacity: 0.8,
  //       strokeWeight: 3,
  //       fillColor: "#6ca1e8",
  //       fillOpacity: 0.5,
  //     };
  //   }
  // }

  const defaultHandleMapClick = (event) => {
    const position = {
      latitude: event.latLng.lat(),
      longitude: event.latLng.lng(),
    };
    const clickedGeofences = geofences.filter((g) =>
      isPointInPolygon(position, g.points)
    );

    if (clickedGeofences.length > 0) {
      if (clickedGeofences.length === 1) {
        setSelectedGeofence(clickedGeofences[0]);
      } else {
        setGeofencesToChooseFrom(clickedGeofences);
      }
    }
  };

  const workOrderIsActive = (wo) => {
    return (
      wo &&
      wo.intervals.some((interval) =>
        isCurrentTimeBetween(interval.start, interval.end)
      )
    );
  };

  useEffect(() => {
    if (filterType === "all") {
      setIncomingGeofences(geofences);
    } else if (filterType === "active") {
      setIncomingGeofences(
        geofences.filter((geofence) =>
          geofence.workOrders.some((workOrder) => workOrderIsActive(workOrder))
        )
      );
    } else if (filterType === "inactive") {
      setIncomingGeofences(
        geofences.filter((geofence) =>
          geofence.workOrders.every(
            (workOrder) => !workOrderIsActive(workOrder)
          )
        )
      );
    } else if (filterType === "none") {
      setIncomingGeofences([]); // Show no geofences
    }
  }, [filterType, geofences]);

  const getIcon = (type) => {
    switch (type) {
      case "all":
        return (
          <FontAwesomeIcon
            color="black"
            style={{ marginLeft: "-2px" }}
            icon={faEye}
          />
        );
      case "active":
        return (
          <FontAwesomeIcon
            color="black"
            style={{ marginLeft: "-2px" }}
            icon={faCheckCircle}
          />
        );
      case "inactive":
        return (
          <FontAwesomeIcon
            color="black"
            style={{ marginLeft: "-2px" }}
            icon={faTimesCircle}
          />
        );
      case "none":
        return (
          <FontAwesomeIcon
            color="black"
            style={{ marginLeft: "-2px" }}
            icon={faEyeSlash}
          />
        );
      default:
        return (
          <FontAwesomeIcon
            color="black"
            style={{ marginLeft: "-2px" }}
            icon={faEye}
          />
        );
    }
  };

  if (!handleMapClick)
    handleMapClick = defaultHandleMapClick;

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <GoogleMap
      onClick={handleMapClick}
      onLoad={handleMapLoad}
      mapContainerStyle={containerStyle}
      center={center}
      zoom={12}
      onZoomChanged={() => mapInstance && setCurrentMapZoom(mapInstance.getZoom())}
      options={{
        disableDefaultUI: true,
        zoomControl: true,
        clickableIcons: false,
        mapTypeControl: true,
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit.station",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
        ],
      }}
    >
      {/*{incomingGeofences && incomingGeofences.map((geofence, index) => <GeofencePolygon*/}
      {/*    key={index}*/}
      {/*    geofence={geofence}*/}
      {/*    geofenceOptions={getOptionsForGeofence(geofence)}*/}
      {/*    onRegularGeofenceClick={(geofence, e) => {*/}
      {/*      handleMapClick(e);*/}
      {/*      handleGeofenceClick && handleGeofenceClick(geofence);*/}
      {/*    }}*/}
      {/*/>)}*/}

      {incomingGeofences && <GeofencesDisplay
          zoom={currentMapZoom}
          geofences={incomingGeofences}
          useClustering={useClustering}
          colorIfActive={colorIfActive}
          onRegularGeofenceClick={(geofence, e) => {
            handleMapClick(e);
            handleGeofenceClick && handleGeofenceClick(geofence);
          }}
      />}
      
      <GeofenceActionsModal
        geofence={selectedGeofence}
        show={selectedGeofence}
        onHide={() => setSelectedGeofence(null)}
        onDelete={() => {
          setShowConfirmDelete(true);
        }}
        onCopy={() => {
          setCopiedGeofence(selectedGeofence);
          toast.success("Copied");
        }}
      />

      <ActionModal
        func={onDeleteGeofence}
        active={showConfirmDelete}
        hideOnConfirm
        onCancel={() => {
          setShowConfirmDelete(false);
        }}
        onConfirm={() => {
          toast.success("Deleted");
          setSelectedGeofence(null);
        }}
        positiveButton={{ variant: "danger" }}
        title={t("dialogs.confirmDeleteDialog.title")}
      >
        {selectedGeofence && (
          <span>
            {t("dialogs.confirmDeleteDialog.youAreAboutTo")}{" "}
            <strong style={{ color: "red" }}>
              {t("dialogs.confirmDeleteDialog.delete")}
            </strong>{" "}
            <strong>{selectedGeofence.name}</strong>.{" "}
            {t("dialogs.confirmDeleteDialog.areYouSure")}
          </span>
        )}
      </ActionModal>

      <ConditionalRender condition={enableFilter}>
        <MapControl position={window.google.maps.ControlPosition.TOP_LEFT}>
          <Col
              style={{
                marginLeft: "0.1rem",
                marginTop: "0.65rem",
                gap: "1rem",
                fontSize: "13px",
              }}
          >
            <div className="btn-group dropend">
              <button
                  type="button"
                  className="btn btn-secondary custom-dropdown-button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "3px",
                    color: "white",
                    backgroundColor: "white",
                  }}
              >
                {getIcon(filterType)}
              </button>
              <ul className="dropdown-menu user-select-none">
                <li>
                  <a
                      className="dropdown-item"
                      onClick={() => setFilterType("all")}
                  >
                    <i className="fas fa-eye me-2"></i>
                    {t("pages.workLocations.registerGeofenceDialog.dropdown_all")}
                  </a>
                </li>
                <li>
                  <a
                      className="dropdown-item"
                      onClick={() => setFilterType("active")}
                  >
                    <i className="fas fa-check-circle me-2"></i>
                    {t(
                        "pages.workLocations.registerGeofenceDialog.dropdown_active"
                    )}
                  </a>
                </li>
                <li>
                  <a
                      className="dropdown-item"
                      onClick={() => setFilterType("inactive")}
                  >
                    <i className="fas fa-times-circle me-2"></i>
                    {t(
                        "pages.workLocations.registerGeofenceDialog.dropdown_inactive"
                    )}
                  </a>
                </li>
                <li>
                  <a
                      className="dropdown-item"
                      onClick={() => setFilterType("none")}
                  >
                    <i className="fas fa-eye-slash me-2"></i>
                    {t(
                        "pages.workLocations.registerGeofenceDialog.dropdown_none"
                    )}
                  </a>
                </li>
              </ul>
            </div>
          </Col>
        </MapControl>
      </ConditionalRender>

      <ChooseGeofenceModal
          active={geofencesToChooseFrom.length > 1}
          geofences={geofencesToChooseFrom}
          title="Choose geofence"
          onCancel={() => setGeofencesToChooseFrom([])}
          onSelect={(geofence) => setSelectedGeofence(geofence)}
      />
    </GoogleMap>
  );
};

GeofencesMap.defaultProps = {
  geofences: [],
  containerStyle: {
    positions: "relative",
    width: "100%",
    height: "100%",
    flexGrow: 1,
  },
};

export default GeofencesMap;
